<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Add items to checklist templates
      </h3>

      <validation-observer ref="checklist-item-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Add below items to the following checklist templates:</label>
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="referenceTypes"
                  :reduce="item => item.value"
                  placeholder="Select checklist type"
                  label="label"
                  v-model="data.reference_type" />
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="items">Items to add:</label>
            <template v-for="(name, index) of data.names">
              <validation-provider
                rules="required"
                :name="'name_' + index"
                v-slot="{ errors }"
                :key="'checklist-item-add-' + index">
                <div class="d-flex mt-2">
                  <div class="w-100">
                    <d-input
                      v-model="data.names[index]"
                      :state="errors.length ? 'invalid' : null" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                  <d-button
                    theme="danger"
                    class="ml-2"
                    @click.prevent="removeItem(index)">
                    <i class="material-icons">delete</i>
                  </d-button>
                </div>
              </validation-provider>
            </template>

            <d-button
              theme="success"
              outline
              class="mt-2 mb-3 w-100"
              @click.prevent="addItem">
              Add item
            </d-button>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'ChecklistItemsPopup',
  computed: {
    referenceTypes () {
      return [
        {
          'value': 'AIRCRAFT',
          'label': 'Aircraft checklists'
        },
        {
          'value': 'AIRPORT',
          'label': 'Airport checklists'
        },
        {
          'value': 'COUNTRY',
          'label': 'Country checklists'
        },
        {
          'value': 'CREW',
          'label': 'Crew checklists'
        },
        {
          'value': 'CUSTOMER',
          'label': 'Customer checklists'
        },
        {
          'value': 'FLIGHT',
          'label': 'Flight checklists'
        },
        {
          'value': 'HOTEL',
          'label': 'Hotel checklists'
        },
        {
          'value': 'PASSENGER',
          'label': 'Passenger checklists'
        }
      ];
    }
  },
  data () {
    return {
      isVisible: false,
      loading: false,
      data: {
        names: [''],
        reference_type: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-checklist-items-popup', this.show);
  },
  methods: {
    show () {
      this.loading = false;
      this.data = {
        names: [''],
        reference_type: null
      };

      setTimeout(() => {
        this.$refs['checklist-item-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['checklist-item-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;

      FormUtils.submit({
        $http: this.$http,
        endpoint: 'check-lists/store-to-all',
        formData: {
          names: this.data.names,
          reference_type: this.data.reference_type
        },
        successTitle: 'Items added',
        successText: 'Items has been added to the selected templates',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the item. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    addItem () {
      this.data.names.push('');
    },
    removeItem (index) {
      this.data.names.splice(index, 1);
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-checklist-items-popup', this.show);
  }
}
</script>
